export const SITE = {
  name: "Kfz-Sachverständiger Francesco Marcone",
  owner: "Francesco Marcone",
  company: "FSP Schaden- und Wertgutachterdienst GmbH",
  partner: "TÜV Rheinland / FSP-Partner",
  street: "Neusser Str. 401–403",
  zip: "50733",
  city: "Köln",
  district: "Nippes",
  phone: "0221 39896336",
  phoneIntl: "+49 221 39896336",
  phoneHref: "tel:+4922139896336",
  mobile: "0157 51534077",
  mobileIntl: "+49 157 51534077",
  mobileHref: "tel:+4915751534077",
  whatsappHref: `https://wa.me/4915751534077?text=${encodeURIComponent(
    "Hallo Herr Marcone, ich hatte einen Unfall und benötige ein Gutachten.",
  )}`,
  email: "francesco.marcone@fsp.de",
  hours: [
    { days: "Mo – Fr", time: "24 Stunden" },
    { days: "Sa – So", time: "nach Vereinbarung" },
  ],
  geo: { lat: 50.97043, lon: 6.95194 },
};

export const SITE_URL = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");

export const img = (name) => ({
  src: `/images/${name}-1600.webp`,
  srcSet: `/images/${name}-800.webp 800w, /images/${name}-1600.webp 1264w`,
});
